import { render, staticRenderFns } from "./ScoreClassTable.vue?vue&type=template&id=8975b40a&scoped=true&"
import script from "./ScoreClassTable.vue?vue&type=script&lang=ts&"
export * from "./ScoreClassTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8975b40a",
  null
  
)

export default component.exports